export const BaseballDiamond = ({ bases, size = 'normal' }) => {
  const sizeClass = size === 'large' ? 'baseball-diamond-large' : 'baseball-diamond';
  
  return (
    <div className={sizeClass} data-testid="baseball-diamond">
      {/* Diamond lines - SVG */}
      <svg 
        viewBox="0 0 120 120" 
        className="absolute inset-0 w-full h-full"
        style={{ pointerEvents: 'none' }}
      >
        {/* Diamond outline */}
        <path
          d="M 60 10 L 110 60 L 60 110 L 10 60 Z"
          fill="none"
          stroke="#8B4513"
          strokeWidth="3"
        />
        {/* Cross lines for infield */}
        <line x1="60" y1="10" x2="60" y2="110" stroke="#8B4513" strokeWidth="2" />
        <line x1="10" y1="60" x2="110" y2="60" stroke="#8B4513" strokeWidth="2" />
      </svg>
      
      {/* Second Base (top) */}
      <div 
        className={`base second ${bases.second ? 'occupied' : ''}`}
        data-testid="base-second"
      />
      
      {/* Third Base (left) */}
      <div 
        className={`base third ${bases.third ? 'occupied' : ''}`}
        data-testid="base-third"
      />
      
      {/* First Base (right) */}
      <div 
        className={`base first ${bases.first ? 'occupied' : ''}`}
        data-testid="base-first"
      />
      
      {/* Home Plate (bottom) */}
      <div 
        className="base home"
        style={{ background: 'white', borderColor: '#1a1a1a' }}
        data-testid="base-home"
      />
    </div>
  );
};

export default BaseballDiamond;
